// extracted by mini-css-extract-plugin
module.exports = {"container":"UspSection_container__RCkvV","title":"UspSection_title__6LMNx","text":"UspSection_text__DmO1e"};